// utils
import axios from '../../utils/axios';

const updatePartnerApi = async (data, partnerId) => {
  try {
    const response = await axios({
      method: 'put',
      url: `/partners/${partnerId}`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { updatePartnerApi };
